import { OverviewStatItemProps } from 'app/fragments/overview-fragment/common/OverviewStatItem';

export const overviewStatData: OverviewStatItemProps[] = [
  {
    value: '0',
    label: 'Activities',
    path: '',
    color: '#ED6060',
  },
  {
    value: '0',
    label: 'Donors',
    path: '',
    color: '#6E5ACC',
  },
  {
    value: '0',
    label: 'Publishers',
    path: '',
    color: '#30C2B0',
  },
  {
    value: '0',
    label: 'Sectors',
    path: '',
    color: '#30C2B0',
  },
  {
    value: '0',
    label: 'Organisations',
    path: '',
    color: '#30C2B0',
  },
];
